import logoTradicional from './logos/tradicional.svg'
import logoBravo from './logos/bravo.png'
import config from '@/core/config'

const brand = config.brand || 'tradicional'

const configs = {
  tradicional: {
    key: 'tradicional',
    name: 'Tradicional',
    legalName: 'Tradicional Bet',
    primaryColor: '#29C353',
    secondaryColor: '#70d50a',
    logo: logoTradicional,
  },
  bravo: {
    key: 'bravo',
    name: 'Bravo',
    // PLACEHOLDER: replace once Bravo's real legal/trading name is confirmed.
    legalName: 'Bravo Bet',
    primaryColor: '#fe0000',
    secondaryColor: '#ff4444',
    // PLACEHOLDER: reuses Tradicional's logo until Bravo's real asset is supplied.
    logo: logoBravo,
  },
}

export default configs[brand] || configs.tradicional
